module.exports = __webpack_public_path__ + "assets/media/lunch.e9a7baff.mp3";